import * as trace from 'owa-trace';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import mailboxCalendarConfiguration from 'owa-service/lib/factory/mailboxCalendarConfiguration';
import OptionsResponseBase from 'owa-service/lib/contract/OptionsResponseBase';
import setMailboxCalendarConfigurationOperation from 'owa-service/lib/operation/setMailboxCalendarConfigurationOperation';
import setMailboxCalendarConfigurationRequest from 'owa-service/lib/factory/setMailboxCalendarConfigurationRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function setMailboxCalendarConfiguration(
    newOptions: MailboxCalendarConfiguration
): Promise<OptionsResponseBase> {
    try {
        return setMailboxCalendarConfigurationOperation(
            setMailboxCalendarConfigurationRequest({
                Header: getJsonRequestHeader(),
                Options: mailboxCalendarConfiguration(newOptions),
            })
        );
    } catch {
        trace.errorThatWillCauseAlert('Getting calendar config failed');
        return Promise.resolve({ WasSuccessful: false });
    }
}
